module.exports = __webpack_public_path__ + "static/favicon-cc38107a7d746e986dc29dd667bb74f2.png";